import getFetcher from 'api/utils/getFetcher';
import { useMemo } from 'react';
import useSWR from 'swr';
import ReleaseFlag from './enumReleaseFlags';

export interface OrganizationReleaseFlagsResult {
  success: boolean;
  // Key is an index number as string, value is the release flag
  data: Record<string, ReleaseFlag>;
}

export interface OrganizationReleaseFlagsError {}

const useOrganizationReleaseFlags = (organizationId?: OrgId) => {
  const queryParams = new URLSearchParams({ orgid: `${organizationId}` });
  const url = organizationId ? `${process.env.VITE_API_ROOT}/releaseflags?${queryParams}` : null;

  const { data, error, isLoading, mutate, isValidating } = useSWR<
    OrganizationReleaseFlagsResult,
    OrganizationReleaseFlagsError
  >(url, getFetcher);

  const organizationReleaseFlags = useMemo(() => new Set(Object.values(data?.data ?? {})), [data]);

  return {
    organizationReleaseFlags,
    error,
    isLoading,
    mutate,
    isValidating,
  };
};

export default useOrganizationReleaseFlags;
